import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '@/models';
import { HeaderItem } from '.';
import IconMenuItem from '@/components/header/pcHeader/menu/IconMenuItem';
import HotIcon from '@/components/icons/HotIcon';
import CaretDownFilledIcon from '@/components/icons/CaretDownFilledIcon';
import { GUIDE_LANG_MAP } from '@/utils/futures';

import BaseSpot from '@/components//icons/header/baseSpot';
import C2c from '@/components//icons/header/c2c';
import CoinTiger from '@/components//icons/header/coinTiger';
import Finance from '@/components//icons/header/finance';
import Ganggan from '@/components//icons/header/ganggan';
import Market from '@/components//icons/header/market';
import Mock from '@/components//icons/header/mock';
import ProSpot from '@/components//icons/header/proSpot';
import Qiquan from '@/components//icons/header/qiquan';
import Staking from '@/components//icons/header/staking';
import Suanli from '@/components//icons/header/suanli';
import TradeIndex from '@/components//icons/header/tradeIndex';
import UsdtTiger from '@/components//icons/header/usdtTiger';
import Etf from '@/components//icons/header/etf';
import Xinyongka from '@/components//icons/header/xinyongka';
import Zhiya from '@/components//icons/header/zhiya';
import { message } from 'antd';
import { getTargetDomain } from '@/utils/utils';

export const useMenuList = () => {
  const { t } = useTranslation();
  const { account, ticker } = useStore();
  const { lang } = account;
  const { uBasedSymbolConfigList, coinBasedSymbolConfigList } = ticker;
  const uBasedSymbol = useMemo(() => {
    if (uBasedSymbolConfigList.length) {
       return uBasedSymbolConfigList[0].symbol;
    }
  }, [uBasedSymbolConfigList]);
  const coinBasedSymbol = useMemo(() => {
    if (coinBasedSymbolConfigList.length) {
      coinBasedSymbolConfigList[0].symbol;
    }
  }, [coinBasedSymbolConfigList]);
  const getGuideUrl = useCallback(() => {
    const url = 'https://support.Tebbit.vip/hc/__lang__/categories/900000041846';
    // @ts-ignore
    const langTemp = GUIDE_LANG_MAP[lang] || 'en-us';

    return url.replace('__lang__', langTemp);
  }, [lang]);

  return useMemo<HeaderItem[]>(
    () => [
      // {
      //   title: t('header.menu.otc'),
      //   url: '/account/otc/list',
      //   baseUrl: '/otc',
      // },
      // {
      //   title: t('header.menu.market'),
      //   url: '/market',
      //   baseUrl: '/market',
      // },
      
      // {
      //   title: t('header.menu.futures'),
      //   url: '/futures/contract/u_based/btc_usdt',
      //   baseUrl: '/futures/contract/u_based',
      // },
      // {
      //   title: t('header.otc'),
      //   url: '/account/otc/index',
      //   icon: <CaretDownFilledIcon />,
      //   baseUrl: '/account/otc/',
      //   children: [
      //     {
      //       title: t('header.otc.title.01'),
      //       subTitle: t('header.otc.subTitle.01'),
      //       url: '/account/otc/index',
      //       titleIcon: <C2c />,
      //     },
      //     {
      //       title: t('header.otc.title.02'),
      //       subTitle: t('header.otc.subTitle.02'),
      //       url: '/account/otc/list',
      //       titleIcon: <Xinyongka />,
      //     },
      //   ],
      // },
      {
        title: t('header.market'),
        url: '/market',
        // icon: <CaretDownFilledIcon />,
        baseUrl: '/market',
        // children: [
        //   {
        //     title: t('header.market.title.01'),
        //     subTitle: t('header.market.subTitle.01'),
        //     url: '/market',
        //     titleIcon: <Market />,
        //   },
        //   {
        //     title: t('header.market.title.02'),
        //     subTitle: t('header.market.subTitle.02'),
        //     url: '/market',
        //     titleIcon: <TradeIndex />,
        //   },
        // ],
      },
      {
        title: t('home.spot'),
        url: '/spot/trade/btc_usdt',
        baseUrl: '/spot/trade',
      },
      // {
      //   title: t('common.spot'),
      //   url: '/spot/trade/btc_usdt',
      //   // icon: <CaretDownFilledIcon />,
      //   baseUrl: '/spot',
      //   // children: [
      //   //   {
      //   //     title: t('header.trade.title.01'),
      //   //     subTitle: t('header.trade.subTitle.01'),
      //   //     url: '/spot/trade/btc_usdt',
      //   //     titleIcon: <BaseSpot />,
      //   //   },
      //   //   {
      //   //     title: t('header.trade.title.02'),
      //   //     subTitle: t('header.trade.subTitle.02'),
      //   //     url: '/',
      //   //     titleIcon: <ProSpot />,
      //   //   },
      //   //   {
      //   //     title: t('header.trade.title.03'),
      //   //     subTitle: t('header.trade.subTitle.03'),
      //   //     url: '/',
      //   //     titleIcon: <Ganggan />,
      //   //   },
      //   // ],
      // },
      // {
      //   title: t('header.derivatives'),
      //   url: '/futures/contract/u_based/btc_usdt',
      //   // icon: <CaretDownFilledIcon />,
      //   baseUrl: '/futures/',
      //   // children: [
      //   //   {
      //   //     title: t('header.derivatives.title.01'),
      //   //     subTitle: t('header.derivatives.subTitle.01'),
      //   //     url: '/futures/contract/u_based/btc_usdt',
      //   //     titleIcon: <UsdtTiger />,
      //   //   },
      //   //   {
      //   //     title: t('header.derivatives.title.02'),
      //   //     subTitle: t('header.derivatives.subTitle.02'),
      //   //     url: '/futures/contract/coin_based/btc_usd',
      //   //     titleIcon: <CoinTiger />,
      //   //   },
      //   //   {
      //   //     title: t('header.derivatives.title.03'),
      //   //     // subTitle: t('header.derivatives.subTitle.03'),
      //   //     url: '/futures/information/fund-rate',
      //   //     titleIcon: <Etf />,
      //   //   },
      //   //   {
      //   //     title: t('header.derivatives.title.04'),
      //   //     subTitle: t('header.derivatives.subTitle.04'),
      //   //     url: '/',
      //   //     titleIcon: <Qiquan />,
      //   //   },
      //   //   {
      //   //     title: t('header.derivatives.title.05'),
      //   //     subTitle: t('header.derivatives.subTitle.05'),
      //   //     url: '/',
      //   //     titleIcon: <Mock />,
      //   //   },
      //   // ],
      // },
      // 跟单
      // {
      //   title: t('header.CopyTrading'),
      //   // url: '/follow',
      //   // baseUrl: '/follow',
      //   onClick: () => {
      //     let url = `/${lang}/copy-trading/futures`; // 拼接路径后跳转
      //     window.open(url, '_blank');
      //   },
      // },
      // 我的资产
      {
        title: t('header.myAssets'),
        url: '/account/assets/total',
        baseUrl: '/account/assets',    
      },
      // 福利中心
      //  {
      //   title: t('header.myAssets'),
      //   url: '/account/assets/total',
      //   baseUrl: '/account/assets',    
      // },
      // {
      //   title: t('header.Savings'),
      //   // url: '/finance/index',
      //   // icon: <CaretDownFilledIcon />,
      //   baseUrl: '/finance',
      //   onClick: () => {
      //     message.success(t('home.jqqd'));
      //   },
      //   // children: [
      //   //   {
      //   //     title: t('header.Savings.title.01'),
      //   //     subTitle: t('header.Savings.subTitle.01'),
      //   //     url: '/finance/index',
      //   //     titleIcon: <Finance />,
      //   //   }, // 二级域名
      //   //   {
      //   //     title: t('header.Savings.title.02'),
      //   //     subTitle: t('header.Savings.subTitle.02'),
      //   //     url: '/finance/staking',
      //   //     titleIcon: <Staking />,
      //   //   }, // 二级域名
      //   //   {
      //   //     title: t('header.Savings.title.03'),
      //   //     subTitle: t('header.Savings.subTitle.03'),
      //   //     url: '/finance/cloudcomputing',
      //   //     titleIcon: <Suanli />,
      //   //   },
      //   //   {
      //   //     title: t('header.Savings.title.04'),
      //   //     subTitle: t('header.Savings.subTitle.04'),
      //   //     url: '/finance/lending',
      //   //     titleIcon: <Zhiya />,
      //   //   },
      //   // ],
      // },
      // {
      //   title: 'NFT',
      //   url: '/ntf',
      //   baseUrl: '/ntf',
      // },
      // {
      //   title: t('header.menu.04'),
      //   url: '/information',
      //   icon: <CaretDownFilledIcon />,
      //   baseUrl: '/information',
      //   children: [
      //     { title: t('info.tab.01.title'), url: getGuideUrl() },
      //     { title: t('info.tab.02.title'), url: '/information/fund-rate' },
      //     { title: t('info.tab.03.title'), url: '/information/risk-fund' },
      //     { title: t('info.tab.04.title'), url: '/information/index' },
      //   ],
      // },
      // {
      //   title: (
      //     <IconMenuItem
      //       title={t('activity.summer.title')}
      //       icon={<HotIcon style={{ marginLeft: '8px', fontSize: '16px' }} />}
      //     />
      //   ),
      //   url: '/activity/summer',
      //   baseUrl: '/activity',
      // },
    ],
    [getGuideUrl],
  );
};
